import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SubmissionError } from "redux-form";
import * as commonActions from "../../../../actions/common.actions";
import { fetchReferrals } from "../../../../actions/dropdowns.actions";
import { createCandidate } from "../../../../actions/user.actions";

import SignUp from "../components/SignUp";
import Section from "../components/Section";
import Categories from "../components/Categories";
import Companies from "../components/Companies";

import styles from "./SignUpMarketingContainer.scss";

import logo from "../../../../assets/images/logo.svg";
import companiesIcon from "../../../../assets/images/companies.svg";
import supportIcon from "../../../../assets/images/support.svg";
import targetIcon from "../../../../assets/images/target.svg";
import dashIcon from "../../../../assets/images/companies/dash.svg";
import doSomethingIcon from "../../../../assets/images/companies/do-something.svg";
import googleIcon from "../../../../assets/images/companies/google.svg";
import makersIcon from "../../../../assets/images/companies/makers.svg";
import microsoftIcon from "../../../../assets/images/companies/microsoft.svg";
import NFLIcon from "../../../../assets/images/companies/nfl.svg";
import viacomIcon from "../../../../assets/images/companies/viacom.svg";

const companiesList = [
  NFLIcon,
  makersIcon,
  viacomIcon,
  dashIcon,
  doSomethingIcon,
  googleIcon,
  microsoftIcon
];

const categoriesList = [
  ["Marketing", "Finance", "Strategy"],
  ["Human Resources", "Creative", "Special Projects"],
  ["Interim C-level Roles", "Parental Leave", "Ongoing Expertise"]
];

class SignUpMarketingContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxError: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(accountData) {
    if (!accountData.terms) {
      this.setState({
        checkboxError:
          "You must agree to our Terms of Service and Privacy Policy to continue."
      });
      throw new SubmissionError({
        terms:
          "You must agree to our Terms of Service and Privacy Policy to continue."
      });
    }

    this.setState({ checkboxError: null });
    this.props.createCandidate(accountData);
  }

  componentWillMount() {
    this.props.fetchReferrals();
  }

  componentDidMount() {
    this.props.commonActions.setHeaderBar({});
  }

  render() {
    return (
      <div id="apply" className={styles.memberSignUp}>
        <section className={styles.hero}>
          <Row className={styles.wrapper}>
            <Col xs={12} md={7} className={styles.intro}>
              <img className={styles.logo} src={logo} />
              <h1 className={styles.title}>Shift the way you work.</h1>
              <h2 className={styles.subtitle}>
                Flexible jobs for professional women.
              </h2>
            </Col>
            <Col xs={12} md={5} className={styles.signup}>
              <SignUp
                onSubmit={this.handleSubmit}
                referrals={this.props.referrals}
                checkboxError={this.state.checkboxError}
              />
            </Col>
          </Row>
        </section>

        <section className={styles.section}>
          <div className={styles.wrapper}>
            <Section
              icon={targetIcon}
              title="We match you with high value opportunities."
              subtitle="Pitch only the jobs you like. <br> Your profile is private until you pitch."
              divider={true}
            />

            <Categories list={categoriesList} />
          </div>
        </section>

        <section className={styles.section}>
          <div className={styles.wrapper}>
            <Section
              icon={companiesIcon}
              title="Work with great companies."
              subtitle="We work with a diverse range of companies, <br> from startups to Fortune 500s."
              divider={true}
            />

            <Companies list={companiesList} />
          </div>
        </section>

        <section className={styles.section}>
          <div className={styles.wrapper}>
            <Section
              icon={supportIcon}
              title="Rely on us for support & resources."
              subtitle="We handle invoicing, payments and tax paperwork."
              divider={false}
            />

            <a className={styles.button} href="#apply">
              Get Started
            </a>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    referrals: state.dropdowns.referrals.data,
    isLoading: state.company.isLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    fetchReferrals: () => dispatch(fetchReferrals()),
    createCandidate: user => dispatch(createCandidate(user))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpMarketingContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/signUpMarketing/containers/SignUpMarketingContainer.js